/***********************************************************************
    DEPLOYMNET TEMPLATE FOR THE FRONTEND
    This file must be placed in src/app/environments/environment.ts
***********************************************************************/

export const environment = {
  production: false,                // do not change
  build: require('../../package.json').version + ' [debug]',

  appVersion: '0.0.0.1',

  appProt: 'https',
  appPath: 'app.',
  appDomain: 'unpispasjorge.mywire.org',
  appPort: null,
  appRoute: '/',

  wwwProt: 'https',
  wwwPath: 'api.',
  wwwDomain: 'unpispasjorge.mywire.org',
  wwwPort: null,
  wwwRoute: '/',

  wsrProt: 'https',
  wsrPath: 'wsr.',
  wsrDomain: 'unpispasjorge.mywire.org',
  wsrPort: 443,
  wsrRoute: '/',

  googleAnalytics: 'G-RXS5XYE475',

  paypal_sandbox: true,             // do not change
  ticketsii_sandbox: true,          // do not change
  ticketbai_sandbox: true,          // do not change
  verifactu_sandbox: true           // do not change
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

import 'zone.js/dist/zone-error';  // Included with Angular CLI.
